module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._b({
    class: [
      'main-container',
      'txt-center' ],
    style: (("border:0.1rem solid " + (_vm.active ? _vm.globalColors.titulo : _vm.globalColors.border) + ";color:" + (_vm.active ? _vm.globalColors.titulo : _vm.globalColors.border))),
    on: {
      "click": _vm.onClick
    }
  }, 'div', _vm.$attrs, false), [_c('div', {
    staticClass: "d-flex align-center justify-center"
  }, [_vm._t("svg")], 2), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('i', {
    class: ['el-icon-success'],
    style: (("color:" + (_vm.active ? _vm.globalColors.primary : _vm.globalColors.border)))
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57b8a4f3","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buy/specialButton.vue
// module id = 666
// module chunks = 32 34